import { render, staticRenderFns } from "./BlockCell.vue?vue&type=template&id=54e662c5&scoped=true"
import script from "./BlockCell.vue?vue&type=script&lang=js"
export * from "./BlockCell.vue?vue&type=script&lang=js"
import style0 from "./BlockCell.vue?vue&type=style&index=0&id=54e662c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e662c5",
  null
  
)

export default component.exports